import { gql } from "@apollo/client";

export const UPDATE_ADDON_TYPE = gql`
  mutation updateAddonType($addonType: AddonTypeUpdateInput!) {
    updateAddonType(addonType: $addonType) {
      id
      name
      category
      displayName
      imageUrl
      hasFixedRate
      hasQuantity
      fixedRate
      description
      code
      recurringRate {
        rateTypeName
        rateTypeDuration
        rate
        longTerm
      }
      totalQuantity
      availableQuantity
      isActivated
      rules {
        from
        to
        amount
      }
    }
  }
`;
